import { ComplexEnumItem } from '../../../utils/complexEnum/ComplexEnumItem'
import { CIMSPageItem } from '../../cimsPage/CIMSPageItem'

/**
 * the item type associated with {@link CustomFieldEntity}
 */
export class CustomFieldEntityItem<
  ClassType extends
    | 'DesignSubmittal'
    | 'ConstructionAdminSubmittal'
    | 'FieldDesignChange'
    | 'ConcreteTestSet',
  ID extends Lowercase<string> = Lowercase<string>,
  PageID extends Lowercase<string> = Lowercase<string>,
  PageName extends string = string,
  PagePathname extends string = string,
  ModuleID extends Lowercase<string> = Lowercase<string>,
  ModuleName extends string = string,
  ModulePathname extends string = string
> extends ComplexEnumItem<ID> {
  /**
   * the human readable name of the entity
   */
  type: ClassType extends 'DesignSubmittal'
    ? 'Design Submittal'
    : ClassType extends 'ConstructionAdminSubmittal'
    ? 'Construction & Admin Submittal'
    : ClassType extends 'FieldDesignChange'
    ? 'Field Design Change'
    : 'Concrete Test Set'
  /**
   * the server-side class type of the entity
   */
  classType: ClassType
  /**
   * the primary key used to index a {@link classType} instance
   */
  key: ClassType extends 'ConcreteTestSet' ? 'globalId' : 'id'
  /**
   * the key of the {@link classType} to be used as the client side label
   */
  label: ClassType extends 'FieldDesignChange'
    ? 'formattedNumber'
    : ClassType extends 'ConcreteTestSet'
    ? 'testSetId'
    : 'sharePointFolderName'
  /**
   * the front end {@link CIMSPageItem} associated with the entity
   */
  page: CIMSPageItem<
    PageID,
    PageName,
    PagePathname,
    ModuleID,
    ModuleName,
    ModulePathname
  >
  constructor({
    classType,
    id,
    key,
    label,
    type,
    page,
  }: Pick<
    CustomFieldEntityItem<
      ClassType,
      ID,
      PageID,
      PageName,
      PagePathname,
      ModuleID,
      ModuleName,
      ModulePathname
    >,
    'classType' | 'id' | 'key' | 'label' | 'page' | 'type'
  >) {
    super(id)
    this.page = page
    this.classType = classType
    this.key = key
    this.label = label
    this.type = type
  }
}
